import React from "react";
import "./loader.css";
import { Skeleton } from "antd";

const Pageloader = () => {
  return (
    <div className="pageloader">
      <Skeleton active />
      <Skeleton active />
    </div>
  );
};

export default Pageloader;
